<form
  [formGroup]="correctStatusForm"
  class="grid">
  <div class="field col-12">
    <label>Stato attuale</label>
    <div class="flex">
      <input
        pInputText
        type="text"
        class="w-full"
        [value]="status?.label || 'Nessuno stato'"
        [disabled]="true" />
    </div>
  </div>

  <div class="field col-12">
    <label>Correggi con lo stato*</label>
    <p-dropdown
      [placeholder]="
        loading
          ? 'Caricamento...'
          : previousStatuses.length === 0
            ? 'Non ci sono stati precedenti disponibili.'
            : 'Scegli...'
      "
      formControlName="previous_status"
      [options]="previousStatuses"
      optionLabel="label"
      styleClass="w-full"
      [filter]="true"
      appendTo="body"
      [emptyMessage]="'Nessun risultato trovato'"
      [disabled]="loading || previousStatuses.length === 0"></p-dropdown>
    <small class="block mt-2 text-500">
      Questa azione riporta indietro lo stato senza rieseguire gli invii email automatici
      collegati al workflow.
    </small>
  </div>
</form>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      icon="pi pi-times"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (click)="save()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="correctStatusForm.invalid">
    </p-button>
  </div>
</div>
